{
  "title": "Candidate Rules",
  "description": "The MCP tools your agents called, grouped by namespace, tool and the arguments they passed. Add a policy rule or a test case at any of those levels.",
  "fetchFailed": "Unable to load tool calls",
  "agentsFailed": "Unable to load the agents that called tools",
  "truncated": "Showing the {{count}} most called records. Narrow the agent or date range to see every call.",
  "filters": {
    "agent": "Agent",
    "allAgents": "All agents",
    "ranges": {
      "1d": "Last day",
      "3d": "Last 3 days",
      "7d": "Last 7 days",
      "all": "All time"
    }
  },
  "breadcrumb": {
    "label": "Tool call level",
    "namespaces": "Namespaces",
    "tools": "Tool Calls",
    "arguments": "Arguments"
  },
  "columns": {
    "namespace": "Namespace",
    "tool": "Tool",
    "tools": "Tools",
    "arguments": "Arguments",
    "argumentNames": "Argument names",
    "argSets": "Arg sets",
    "agents": "Agents",
    "calls": "Calls",
    "firstSeen": "First seen",
    "lastSeen": "Last seen"
  },
  "noArguments": "No arguments",
  "agentCount": "{{count}} agents",
  "actions": {
    "addToPolicy": "Add to policy",
    "addTestCase": "Add test case"
  },
  "policyModal": {
    "title": "Add a rule for {{target}}",
    "body": "The rule opens in the policy editor matching this {{level}}. Choose its recourse there, and fill in the values for any arguments it checks.",
    "levels": {
      "namespace": "namespace",
      "tool": "tool",
      "arguments": "tool and argument names"
    },
    "policyLabel": "Policy",
    "newPolicy": "A new policy",
    "truncated": "Showing the newest {{count}} policies.",
    "submit": "Open in editor"
  },
  "caseModal": {
    "title": "Add a test case for {{target}}",
    "body": "The call is added to a saved test case, or starts a new one, in the case editor. Fill in the argument values and the expected outcome there before saving.",
    "caseLabel": "Test case",
    "newCase": "A new test case",
    "truncated": "Showing the newest {{count}} test cases.",
    "submit": "Open in editor"
  },
  "picker": {
    "open": "From candidate rules",
    "title": "Add a rule from candidate rules",
    "body": "Pick a tool your agents have called, then what the rule matches. Choose its recourse in the rule card, and fill in values for any arguments it checks.",
    "search": "Search tools",
    "tools": "Tools your agents called",
    "calls": "{{count}} calls",
    "more": "Showing {{shown}} of {{count}} tools. Search to narrow the list.",
    "partial": "Totals cover the most called records only.",
    "noMatches": "No tools match your search",
    "matchLegend": "Match",
    "matchTool": "Any call to <code>{{tool}}</code>",
    "matchNamespace": "Any tool in the <code>{{namespace}}</code> namespace",
    "matchArgs": "Calls passing the arguments you choose",
    "argsPlaceholder": "Search argument names",
    "noArgMatches": "No argument names match",
    "submit": "Add rule"
  },
  "emptyTitle": "No tool calls yet",
  "emptyMessage": "Calls appear here once your agents call MCP tools through AURA. Try a wider date range or another agent."
}
